import LogoIcon from '../../../icons/LogoIcon';
import SocialPagesList from './SocialPagesList';
import StaticPagesList from './StaticPagesList';
import styles from './styles.module.scss';

const CatalogFooter = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.logo}>
                <LogoIcon />
            </div>
            <StaticPagesList />
            <SocialPagesList />
        </footer>
    );
};

export default CatalogFooter;
